// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"e78fa4ae","453":"0cf0a482"}[chunkId] + ".chunk.js";
};